import { NOT_CHECK_STATUS } from '@/constants';
import i18n from '@/i18n';

export function useRenderStatusComposable() {
  const renderStatus = (status: number) => {
    if (status === NOT_CHECK_STATUS) {
      return i18n.global.t('my_quote.not_checked');
    }
    return status ? i18n.global.t('my_quote.pass') : i18n.global.t('my_quote.fail');
  };

  const renderStatusYesNo = (status: number) => {
    if (status === NOT_CHECK_STATUS) {
      return i18n.global.t('my_quote.not_checked');
    }
    return status ? i18n.global.t('common.yes') : i18n.global.t('common.no');
  };

  const renderClass = (status: number) => {
    if (status === NOT_CHECK_STATUS) {
      return 'unchecked';
    }
    return status ? 'pass-status' : 'fail-status';
  };

  const renderStatusYesNoSpecial = (status: number) => {
    if (status === NOT_CHECK_STATUS) {
      return i18n.global.t('my_quote.not_checked');
    }
    return status ? i18n.global.t('common.no') : i18n.global.t('common.yes');
  };

  const renderClassSpecial = (status: number) => {
    if (status === NOT_CHECK_STATUS) {
      return 'unchecked';
    }
    return status ? 'fail-status' : 'pass-status';
  };

  const getTagSeverity = (status: string) => {
    if (status === null) {
      return 'warning';
    }
    return status ? 'success' : 'danger';
  };

  const getTagValue = (status: string) => {
    if (status === null) {
      return i18n.global.t('my_quote.not_run');
    }
    return status ? i18n.global.t('my_quote.pass').toUpperCase() : i18n.global.t('my_quote.fail').toUpperCase();
  };

  return {
    renderStatus,
    renderStatusYesNo,
    renderClass,
    getTagSeverity,
    getTagValue,
    renderStatusYesNoSpecial,
    renderClassSpecial
  };
}
